<template>
    <div>
        <section class="about-us section-padding pb-26-until-sm">
            <div class="text-left">
                <div class="mt-60">
                    <h4 class="hZUCZe">{{ $t('We connect ideas, drive results') }}</h4>
                    <h1 class="mb-10 text-h2-sans">{{ $t('Technology and') }}<br>{{ $t('Strategic Innovation') }}</h1>
                </div>
            </div>
            <video  playsinline 
            autoplay 
            loop 
            muted 
            preload="auto"
            defaultMuted
            webkit-playsinline="true"
            x5-video-player-type="h5"
            x5-video-player-fullscreen="true"
            x5-video-orientation="portraint"
            aria-label="Background Video" class="video-section mt-30">
                <source :src="video_service7Mp4" type="video/mp4">
                <!-- Fallback for unsupported formats -->
                Your browser does not support HTML5 video.
            </video>
            
        </section>
    </div>
</template>
<script>
import video_service7Mp4 from '@/assets/videos/34507792.mp4'
export default{
    name: "SectionAComponent",
    data() {
        return {
            video_service7Mp4
        };
    },
   
}
</script>
<style scoped>
.video-section{
    width: 100%;
}
</style>